export type BrandThemeModel = {
  id: number,
  brand_id: number,
  title: string,
}
export type BrandThemeRequestOptions = {}

const state = {
  id: null,
  brand_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'title' },
]

export default state
